import * as React from 'react';
import { BodyCell } from './BodyCell';
import { DataAttributes } from './DataAttributes';
import { DefaultFormatter } from './DefaultFormatter';
import { HeaderColumn } from './HeaderColumn';

export class RowHeaderCell extends React.PureComponent<RowHeaderCell.Props> {

  public static displayName: string = 'DataGridRowHeaderCell';

  public render(): JSX.Element {
    return (this.props.rowType === RowHeaderCell.RowType.Header) ? this.renderHeaderRowHeaderCell() : this.renderBodyRowHeaderCell();
  }

  private renderHeaderRowHeaderCell = (): JSX.Element => {
    const outerAttrs = HeaderColumn.getDivWrapperProps(this.props.isSelected, true);
    outerAttrs.style!.width = RowHeaderCell.Width;
    outerAttrs.style!.verticalAlign = 'top';

    const innerAttrs: React.HTMLAttributes<HTMLDivElement> & DataAttributes = {
      'data-tb-test-id': `${this.props.testId}${RowHeaderCell.CellTestIdSuffix}`,
      className: 'tb-react-dg-hcell',
      onClick: this.props.onRowHeaderCellClick,
      role: 'button',
      style: { height: '100%' }
      // TODO localized title
    };

    return (
      <div {...outerAttrs}>
        <div {...innerAttrs}></div>
      </div>
    );
  }

  private renderBodyRowHeaderCell = (): JSX.Element => {
    const style = BodyCell.getStyle(this.props.isSelected, this.props.height, RowHeaderCell.Width, true);

    const content: JSX.Element =
      <DefaultFormatter value={''} testId={`${this.props.testId}${RowHeaderCell.CellTestIdSuffix}-Cell`} />;

    const attrs: React.HTMLAttributes<HTMLDivElement> & DataAttributes = {
      'data-tb-test-id': `${this.props.testId}${RowHeaderCell.CellTestIdSuffix}`,
      onClick: this.props.onRowHeaderCellClick,
      style: style,
      role: 'button',
      // TODO localized title
    };

    return (
      <div {...attrs}>{content}</div>
    );
  }
}

export namespace RowHeaderCell {

  export const CellTestIdSuffix = '-rowHeaderCell';

  export const Width = 10;

  export enum RowType {
    Header,
    Body
  }

  export interface Props {
    height?: number;
    isSelected: boolean;
    onRowHeaderCellClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    rowType: RowType;
    testId: string;
  }
}
